// removed by extract-text-webpack-plugin
module.exports = {"clickThrough":"clickThrough__14uxd","menu":"menu__3UCwx","menuDiv":"menuDiv__T702Z","countryItem":"countryItem__Zxksl","code":"code__20W11","name":"name__1JtHL","flag":"flag__j_Kgj"};


//////////////////
// WEBPACK FOOTER
// ./components/countrySelect/style.scss
// module id = akk8
// module chunks = 1